import {
  FaBehance,
  FaBirthdayCake,
  FaDribbble,
  FaFacebookF,
  FaGithub,
  FaGitlab,
  FaGlobeAmericas,
  FaInstagram,
  FaLinkedinIn,
  FaSkype,
  FaStackOverflow,
  FaTelegram,
  FaYoutube,
  FaTwitter,
  FaMapMarkerAlt,
} from 'react-icons/fa';
import { MdEmail, MdPhone } from 'react-icons/md';

const Icons = {
  phone: MdPhone,
  address: FaMapMarkerAlt,
  website: FaGlobeAmericas,
  email: MdEmail,
  facebook: FaFacebookF,
  twitter: FaTwitter,
  linkedin: FaLinkedinIn,
  github: FaGithub,
  dribbble: FaDribbble,
  instagram: FaInstagram,
  stackoverflow: FaStackOverflow,
  behance: FaBehance,
  gitlab: FaGitlab,
  birthday: FaBirthdayCake,
  telegram: FaTelegram,
  skype: FaSkype,
  youtube: FaYoutube,
};

export default Icons;
